import { useCallback } from 'react';

import { usePintoWriterCampaignLazyQuery } from '../core/graphql/operation-hooks';

const useQueryPintoWriterCampaign = () => {
  const [queryPintoWriterCampaign, { data, loading }] = usePintoWriterCampaignLazyQuery({ fetchPolicy: 'network-only' });

  const fetchPintoWriterCampaign = useCallback(
    async (productCampaignId: string) => {
      await queryPintoWriterCampaign({
        variables: {
          productCampaignId,
        },
      });
    },
    [queryPintoWriterCampaign],
  );

  return {
    fetchPintoWriterCampaign,
    pintoWriterCampaign: data?.pintoWriterCampaign,
    isLoadingPintoWriterCampaign: loading,
  };
};

export default useQueryPintoWriterCampaign;
